import { Outlet, type RouteObject } from 'react-router';

import { StyleScope } from '@/features/shared/style-scope';

export const onboardingRoutes: RouteObject[] = [
    {
        path: '',
        element: <StyleScope name='onboarding-ui' />,
        children: [
            {
                path: 'onboarding',
                element: <Outlet />,
                children: [
                    {
                        path: '',
                        async lazy() {
                            const { businessInfoWrapper } =
                                await unwrapFeatures();
                            return businessInfoWrapper().then((m) => ({
                                Component: m.default,
                            }));
                        },
                        children: [
                            {
                                path: 'business-details',
                                async lazy() {
                                    const { businessDetails } =
                                        await unwrapFeatures();
                                    return businessDetails().then((m) => ({
                                        Component: m.default,
                                    }));
                                },
                            },
                            {
                                path: 'first-branch',
                                async lazy() {
                                    const { firstBranch } =
                                        await unwrapFeatures();
                                    return firstBranch().then((m) => ({
                                        Component: m.default,
                                    }));
                                },
                            },
                            {
                                path: 'brm-details',
                                async lazy() {
                                    const { brmDetails } =
                                        await unwrapFeatures();
                                    return brmDetails().then((m) => ({
                                        Component: m.default,
                                    }));
                                },
                            },
                        ],
                    },
                    {
                        path: 'tasks',
                        async lazy() {
                            const { onboardingTasks } = await unwrapFeatures();
                            return onboardingTasks().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: 'request-data-entry',
                        async lazy() {
                            const { requestDataEntry } = await unwrapFeatures();
                            return requestDataEntry().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                ],
            },
            {
                path: 'onboarding/business-email',
                async lazy() {
                    const { businessEmailGuard } = await unwrapFeatures();
                    return businessEmailGuard().then((m) => ({
                        Component: m.default,
                    }));
                },
                children: [
                    {
                        path: 'create',
                        async lazy() {
                            const { enterEmailAddress } =
                                await unwrapFeatures();
                            return enterEmailAddress().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: 'verify',
                        async lazy() {
                            const { verifyEmailAddress } =
                                await unwrapFeatures();
                            return verifyEmailAddress().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: 'complete',
                        async lazy() {
                            const { completeEmailFlow } =
                                await unwrapFeatures();
                            return completeEmailFlow().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                ],
            },
            {
                path: 'onboarding/sales-assist',
                async lazy() {
                    const { salesAssist } = await unwrapFeatures();
                    return salesAssist().then((m) => ({
                        Component: m.default,
                    }));
                },
            },
            {
                path: 'no-business',
                async lazy() {
                    const { noBusiness } = await unwrapFeatures();
                    return noBusiness().then((m) => ({ Component: m.default }));
                },
            },
            {
                path: 'implementation',
                async lazy() {
                    const { taskConfirmationGuard } = await unwrapFeatures();
                    return taskConfirmationGuard().then((m) => ({
                        Component: m.default,
                    }));
                },
                children: [
                    {
                        path: ':taskId/confirm-completion',
                        async lazy() {
                            const { confirmImplementationCompletion } =
                                await unwrapFeatures();
                            return confirmImplementationCompletion().then(
                                (m) => ({ Component: m.default }),
                            );
                        },
                    },
                ],
            },
        ],
    },
];

async function unwrapFeatures() {
    const features = await import('onboarding/features');

    return features.default;
}
